import { parse } from "qs";
import { useLocation } from "@tanstack/react-router";

export default function useQueryString<T>(): T {
  const location = useLocation();
  const parsedQs = parse(location.search, { ignoreQueryPrefix: true });
  return parsedQs as T;
}
